<template>
  <div class="row">
    <div class="col-md-12">
      <SelectsV2
        v-if="enableSelect == 1"
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
        :disabledMicroArea="loading"
      />
      <SelectsV2
        v-if="enableSelect == 2"
        :activeSelectEquipes="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
        :disabledMicroArea="loading"
      />
    </div>
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs tabs-auto"
        v-model="tabsActive"
      >
        <b-tab title="Pessoas" active>
          <template #title> <i class="icofont-list"></i> Pessoas </template>
          <div class="info-table py-4">
            <div class="info-table-item">
              <Subtitle
                @exibirVermelhos="handleExibirVermelhos"
                @exibirVerdes="handleExibirVerdes"
                :setRed="setRed"
              />
            </div>
            <div class="info-table-item">
              <vue-select
                v-model="selectedFilterBoasPraticas"
                :options="optionsFilterBoasPraticas"
                label="label"
                placeholder="Boas práticas"
                :clearable="true"
                @input="onChangeFilterBoasPraticas"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="info-table-item">
              <download-files
                ref="downloadFiles"
                :callback-pdf="generatePdf"
                :data="displayedCadastros"
                :fields="dataFields"
                name="pessoa-hipertensa"
                pdf-label="Hipertensos filtrados PDF"
                xls-label="Hipertensos filtrados XLS"
              >
                <template #items>
                  <button
                    class="dropdown-item btn-exportar"
                    @click.stop.prevent="
                      $refs.downloadFiles.openWarning(null, exportarHipertensos)
                    "
                    :disabled="loadingExportarHipertensos"
                  >
                    <b-spinner
                      small
                      class="mr-2"
                      v-if="loadingExportarHipertensos"
                    ></b-spinner>

                    <i class="icofont-file-excel" v-else></i>
                    {{
                      loadingExportarHipertensos
                        ? 'Baixando todos os hipertensos...'
                        : 'Todos os hipertensos XLS'
                    }}
                  </button>
                  <button
                    class="dropdown-item btn-exportar"
                    @click.stop.prevent="
                      $refs.downloadFiles.openWarning(
                        null,
                        abrirModalExportarProcedimentos
                      )
                    "
                  >
                    <i class="icofont-file-excel"></i>
                    Todos os procedimentos XLS
                  </button>
                </template>
              </download-files>
            </div>
          </div>
          <TabelaCadastros
            ref="table"
            :cadastros="displayedCadastros"
            :loading="loading"
            :selectedFilterBoasPraticas="selectedFilterBoasPraticas"
            @filterSearch="filterSearch"
          />
        </b-tab>

        <b-tab title="Percentual">
          <template #title>
            <i class="icofont-mathematical-alt-1"></i> Percentual
          </template>
          <div class="row mt-4">
            <div class="col-md-4">
              <vue-select
                v-model="selectedFilterBoasPraticasTabelaPercentual"
                :options="optionsFilterBoasPraticas"
                label="label"
                placeholder="Boas práticas"
                :clearable="true"
                @input="onChangeFilterBoasPraticasPercentual"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <TabelaPercentual
            :loading="loading"
            :municipio="dadosPercentualMunicipio"
            :equipe="dadosPercentualEquipe"
            :micro_area="dadosPercentualMicroArea"
            :selectedEquipe="equipe"
            :selectedMicroArea="microArea"
            :selectedFilterBoasPraticas="
              selectedFilterBoasPraticasTabelaPercentual
            "
            :tipoResultado="tipoResultadoPercentual"
            @changeTipoResultado="changeTipoResultadoPercentual"
          />
          <GraficoPercentual
            :equipe="equipe"
            :micro_area="microArea"
            :selectedFilterBoasPraticas="
              selectedFilterBoasPraticasTabelaPercentual
            "
            :tipoResultado="tipoResultadoGrafico"
            @changeTipoResultado="changeTipoResultadoGrafico"
            ref="graficoPercentual"
          />
        </b-tab>
      </b-tabs>
    </div>

    <ModalExportarProcedimentos
      :show.sync="showModalExportarProcedimentos"
      :on-confirm="onConfirmExportarProcedimentos"
    />
  </div>
</template>

<script>
import Subtitle from './components/Subtitle.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import { dataFields } from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import TitleTag from '@/components/TitleTag.vue'
import TabelaCadastros from './components/TabelaCadastros.vue'
import SelectsV2 from '@/components/utils/SelectsV2.vue'
import TabelaPercentual from './components/TabelaPercentual.vue'
import GraficoPercentual from './components/GraficoPercentual.vue'
import ModalExportarProcedimentos from './components/ModalExportarProcedimentos.vue'

export default {
  name: 'PessoaHipertensao',
  components: {
    Subtitle,
    PulseLoader,
    apexchart: VueApexCharts,
    DownloadFiles,
    TitleTag,
    TabelaCadastros,
    SelectsV2,
    TabelaPercentual,
    GraficoPercentual,
    ModalExportarProcedimentos,
  },
  mixins: [utils],
  data() {
    return {
      enableSelect: '',
      equipe: '',
      microArea: '',
      microAreas: [],
      cadastros: [],
      cadastrosOriginais: [],
      dadosPercentualMunicipio: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosPercentualEquipe: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosPercentualMicroArea: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosTabelaPercentual: [],
      dadosGraficoPercentual: [],
      loading: false,
      tabsActive: 0,
      setRed: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      filterSearchTable: false,
      dataFields: { ...dataFields },
      selectedFilterBoasPraticas: null,
      selectedFilterBoasPraticasTabelaPercentual: null,
      optionsFilterBoasPraticas: [
        {
          label: 'Todas',
          value: null,
          key: 'todas',
          key_percentual: 'todas',
        },
        {
          label: 'Consultas',
          value: 'a_pb',
          key: 'consultas',
          key_percentual: 'fai',
        },
        {
          label: 'Aferição PA',
          value: 'b_pb',
          key: 'afericao-pa',
          key_percentual: 'pa',
        },
        {
          label: 'Visitas ACS / TACS',
          value: 'c_pb',
          key: 'visitas',
          key_percentual: 'fvdt',
        },
        {
          label: 'Peso e altura',
          value: 'd_pb',
          key: 'peso-altura',
          key_percentual: 'pes_alt',
        },
      ],
      loadingExportarHipertensos: false,
      showModalExportarProcedimentos: false,
      tipoResultadoPercentual: 'quadrimestral',
      tipoResultadoGrafico: 'quadrimestral',
    }
  },

  computed: {
    displayedCadastros() {
      if (this.filterSearchTable) return this.filterSearchTable

      const resultado = Filter.filtro(
        this.cadastros,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes,
        this.selectedFilterBoasPraticas
      )
      return resultado || []
    },
  },

  methods: {
    /**
     * Aplica os filtros de exibição dos cadastros.
     *
     * @param {Boolean} vermelho Exibe apenas cadastros pendentes.
     * @param {Boolean} verde Exibe apenas cadastros concluídos.
     */
    filtros(vermelho, verde) {
      if (this.$refs.table) this.$refs.table.search = ''
      this.setRed = vermelho
      this.exibirCadastrosVermelhos = vermelho
      this.exibirCadastrosVerdes = verde && !vermelho
    },

    /**
     * Atualiza o resultado da busca da tabela.
     *
     * @param {Object} item Objeto retornado pelo componente da tabela.
     */
    filterSearch(item) {
      this.filterSearchTable = item.filter || false
    },

    /**
     * Exibe apenas os registros vermelhos.
     *
     * @param {Boolean} valor Estado do filtro.
     */
    handleExibirVermelhos(valor) {
      this.filtros(valor, false)
    },

    /**
     * Exibe apenas os registros verdes.
     *
     * @param {Boolean} valor Estado do filtro.
     */
    handleExibirVerdes(valor) {
      this.filtros(false, valor)
    },

    /**
     * Atualiza a equipe selecionada e recarrega os dados.
     *
     * @param {Object} event Equipe selecionada.
     * @returns {Promise<void>}
     */
    async onChangeEquipe(event) {
      if (this.$refs.table) this.$refs.table.search = ''

      this.equipe = event
      this.microArea = ''
      this.resetDadosMicroArea()

      if (event) {
        this.tabsActive = 0
        this.resetCadastros()
        await this.buscarCadastrosPorEquipe()
      } else {
        this.resetDadosEquipe()
        this.resetCadastros()
      }

      this.setarPercentualEquipe()
    },

    /**
     * Atualiza a microárea selecionada e recarrega os dados.
     *
     * @param {Object} event Microárea selecionada.
     * @returns {Promise<void>}
     */
    async onChangeMicroArea(event) {
      if (this.$refs.table) this.$refs.table.search = ''
      this.tabsActive = 0
      this.microArea = event?.micro_area || ''
      this.resetDadosMicroArea()

      if (event && this.microArea) {
        this.loading = true
        await this.buscarCadastrosMicroArea()
        this.loading = false
      } else {
        await this.onChangeEquipe(this.equipe)
      }

      this.setarPercentualMicroArea()
    },

    /**
     * Busca os cadastros da equipe selecionada.
     *
     * @returns {Promise<void>}
     */
    async buscarCadastrosPorEquipe() {
      this.loading = true

      try {
        const resposta = await Functions.getCadastrosPorEquipe(
          this.$store.state.cod_ibge,
          this.equipe.ine_esf_eap
        )

        if (resposta) {
          this.cadastros = resposta
          this.cadastrosOriginais = resposta
          this.filtros(true, false)
        }
      } finally {
        this.loading = false
      }
    },

    /**
     * Busca os cadastros da microárea selecionada.
     *
     * @returns {Promise<void>}
     */
    async buscarCadastrosMicroArea() {
      this.loading = true
      const resposta = await Functions.getCadastrosPorMicroArea(
        this.$store.state.cod_ibge,
        this.equipe.ine_esf_eap,
        this.microArea
      )
      if (resposta) {
        this.cadastros = resposta
        this.cadastrosOriginais = resposta
        this.filtros(true, false)
      }
      this.loading = false
    },

    /**
     * Manipula ao alterar o filtro de boas práticas
     * @param {Object} item
     *
     * @returns {void}
     */
    onChangeFilterBoasPraticas(item) {
      this.handleExibirVermelhos(true)
    },

    /**
     * Manipula a alteração do filtro de boas práticas do percentual.
     *
     * Quando o filtro for diferente de "Todas", força tabela e gráfico
     * para o resultado quadrimestral.
     *
     * @param {Object|null} item Filtro selecionado.
     * @returns {void}
     */
    onChangeFilterBoasPraticasPercentual(item) {
      if (item && item.value != null) {
        this.tipoResultadoPercentual = 'quadrimestral'
        this.tipoResultadoGrafico = 'quadrimestral'
      }

      this.setarPercentualMunicipio()

      if (this.equipe != '') {
        this.setarPercentualEquipe()
      }

      if (this.microArea != '') {
        this.setarPercentualMicroArea()
      }

      this.$nextTick(() => {
        this.changeTipoResultadoGrafico(this.tipoResultadoGrafico)
      })
    },

    /**
     * Calcula e atualiza o percentual do município.
     */
    setarPercentualMunicipio() {
      const resultado = Functions.percentualMunicipio(
        this.dadosGraficoPercentual,
        this.selectedFilterBoasPraticasTabelaPercentual
      )
      Object.assign(this.dadosPercentualMunicipio, resultado)
      this.$refs.graficoPercentual.serieHistoricaMunicipio(
        this.dadosGraficoPercentual
      )
    },

    /**
     * Calcula e atualiza o percentual da equipe.
     */
    setarPercentualEquipe() {
      const resultado = Functions.percentualEquipe(
        this.dadosGraficoPercentual,
        this.equipe.ine_esf_eap,
        this.selectedFilterBoasPraticasTabelaPercentual
      )
      Object.assign(this.dadosPercentualEquipe, resultado)
      this.$refs.graficoPercentual.serieHistoricaEquipe(
        this.dadosGraficoPercentual,
        this.equipe
      )
    },

    /**
     * Calcula e atualiza o percentual da microárea.
     */
    async setarPercentualMicroArea() {
      if (!this.microArea) return
      const resultado = Functions.percentualMicroArea(
        this.dadosGraficoPercentual,
        this.equipe.ine_esf_eap,
        this.microArea,
        this.selectedFilterBoasPraticasTabelaPercentual
      )
      Object.assign(this.dadosPercentualMicroArea, resultado)
      this.$refs.graficoPercentual.serieHistoricaMicroArea(
        this.dadosGraficoPercentual,
        this.equipe,
        this.microArea
      )
    },

    /**
     * Limpa a lista de cadastros carregados.
     */
    resetCadastros() {
      this.cadastros = []
      this.cadastrosOriginais = []
    },

    /**
     * Reseta os dados da equipe selecionada.
     */
    resetDadosEquipe() {
      this.equipe = ''
      this.dadosPercentualEquipe = {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      }
    },

    /**
     * Reseta os dados da microárea selecionada.
     */
    resetDadosMicroArea() {
      this.dadosPercentualMicroArea = {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      }
    },

    /**
     * Altera o tipo de resultado da tabela percentual.
     *
     * Se o filtro de boas práticas for diferente de "Todas",
     * mantém travado em quadrimestral.
     *
     * @param {String} tipo Tipo do resultado.
     * @returns {void}
     */
    changeTipoResultadoPercentual(tipo) {
      if (
        this.selectedFilterBoasPraticasTabelaPercentual &&
        this.selectedFilterBoasPraticasTabelaPercentual.value != null
      ) {
        tipo = 'quadrimestral'
      }

      this.tipoResultadoPercentual = tipo

      this.setarPercentualMunicipio()

      if (this.equipe) {
        this.setarPercentualEquipe()
      }

      if (this.microArea) {
        this.setarPercentualMicroArea()
      }
    },

    /**
     * Altera o tipo de resultado do gráfico.
     *
     * Se o filtro de boas práticas for diferente de "Todas",
     * mantém travado em quadrimestral.
     *
     * @param {String} tipo Tipo do resultado.
     * @returns {void}
     */
    changeTipoResultadoGrafico(tipo) {
      if (
        this.selectedFilterBoasPraticasTabelaPercentual &&
        this.selectedFilterBoasPraticasTabelaPercentual.value != null
      ) {
        tipo = 'quadrimestral'
      }

      this.tipoResultadoGrafico = tipo

      this.$nextTick(() => {
        this.$refs.graficoPercentual.serieHistoricaMunicipio(
          this.dadosGraficoPercentual
        )

        if (this.equipe) {
          this.$refs.graficoPercentual.serieHistoricaEquipe(
            this.dadosGraficoPercentual,
            this.equipe
          )
        }

        if (this.microArea) {
          this.$refs.graficoPercentual.serieHistoricaMicroArea(
            this.dadosGraficoPercentual,
            this.equipe,
            this.microArea
          )
        }
      })
    },

    /**
     * Gera o PDF com os cadastros exibidos.
     */
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.microArea,
        this.selectedFilterBoasPraticas
      )
    },

    /**
     * Abre o modal para exportação de todos os procedimentos.
     */
    abrirModalExportarProcedimentos() {
      this.showModalExportarProcedimentos = true
    },

    /**
     * Confirma a exportação e dispara o download do XLS de procedimentos.
     * @param {{ ano: number, mes: number }} param0 - Ano e mês selecionados no modal
     */
    async onConfirmExportarProcedimentos({ ano, mes }) {
      try {
        this.$refs.downloadFiles.postLog()
        await Functions.exportarProcedimentos(
          this.$store.state.cod_ibge,
          ano,
          mes
        )
      } catch (error) {
        console.error(error)
        this.$toast.error('Não foi possível exportar o arquivo.', 'Erro:')
        throw error
      }
    },

    /**
     * Exporta os dados dos hipertensos
     */
    async exportarHipertensos() {
      try {
        if (this.loadingExportarHipertensos) return

        this.loadingExportarHipertensos = true
        this.$refs.downloadFiles.postLog()

        const response = await this.$api.get(
          `/app/pessoa-hipertensao/${this.$store.state.cod_ibge}/exportar-dados`,
          {
            responseType: 'blob',
          }
        )

        const blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel',
        })

        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'todos-hipertensos.xls'

        document.body.appendChild(link)
        link.click()
        link.remove()

        window.URL.revokeObjectURL(url)

        this.$toast.success('Download iniciado com sucesso.', 'Sucesso:', {
          position: 'topRight',
        })
      } catch (error) {
        console.error(error)
        this.$toast.error('Não foi possível exportar o arquivo.', 'Erro:')
      } finally {
        this.loadingExportarHipertensos = false
      }
    },

    /**
     * Inicializa  os dados
     */
    async init() {
      try {
        const response2 = await this.$api.get(
          `/app/v2/serie-historica/${this.$store.state.cod_ibge}/indicador/[50]`
        )
        this.dadosGraficoPercentual = response2.data
        this.setarPercentualMunicipio()
        // Enfermeiro, médico ...
        if (this.enableSelect == 2) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
            await this.buscarCadastrosPorEquipe()
            this.setarPercentualEquipe()
          }
        }

        // ACS
        if (this.enableSelect == 3) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
            this.setarPercentualEquipe()
          }
          this.microArea = this.$store.state.micro_area
          await this.buscarCadastrosMicroArea()
          this.setarPercentualMicroArea()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },

  created() {
    this.enableSelect = this.enableSelects()
    this.init()
  },
}
</script>

<style scoped></style>
